<ng-container [ngSwitch]="modalityId$ | async">
  <ng-container *ngSwitchCase="DNA_MODALITY_ID">
    <app-system-overview-syngovia></app-system-overview-syngovia>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <app-system-overview-default></app-system-overview-default>
  </ng-container>
</ng-container>
